import 'dayjs/locale/es';

import dayjs from 'dayjs';

dayjs.locale('es');

export const DateHelper = (date: string, format?: string) => dayjs(date).format('D MMMM, YYYY');
export const DateHelperShort = (date: string) => dayjs(date).format('D MMM YYYY');

export const DateAddedMonths = (date: string, term: number) => dayjs(date).add(term, 'months').format('DD/MM/YYYY');

const padNumber = (num: number): string => (num < 10 ? `0${num}` : `${num}`);

export const convertDateFormatData = (inputDate: string): string => {
  const date = new Date(inputDate);
  return `${padNumber(date.getDate())}/${padNumber(
    date.getMonth() + 1,
  )}/${date.getFullYear()}`;
};

export const getTodayDate = () => {
  const today = new Date();
  const monthDate = today.getMonth() + 1 < 10
    ? `0${today.getMonth() + 1}`
    : today.getMonth() + 1;
  const dayDate = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  return `${today.getFullYear()}-${monthDate}-${dayDate}`;
};
